import styles from "./CartSidebar.module.css";

export default function CartSidebar({ cart, onClose, onCheckout, onClear }) {
  const total = cart.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.sidebar} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <h3>Your Cart</h3>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {cart.length > 0 && (
              <button className={styles.clearBtn} onClick={onClear} title="Clear cart">
                Clear
              </button>
            )}
            <button className={styles.close} onClick={onClose}>✕</button>
          </div>
        </div>

        {cart.length === 0 ? (
          <div className="empty-state">
            <h3>Cart is empty</h3>
            <p>Add products through the chat</p>
          </div>
        ) : (
          <>
            <div className={styles.items}>
              {cart.map((item, i) => (
                <div key={i} className={styles.item}>
                  <div className={styles.itemImg}>
                    {item.image
                      ? <img src={item.image} alt={item.name} onError={e => { e.target.style.display="none"; }} />
                      : <span>◈</span>}
                  </div>
                  <div className={styles.itemInfo}>
                    <div className={styles.itemName}>{item.name}</div>
                    <div className={styles.itemPrice}>₹{item.price?.toLocaleString()} × {item.quantity}</div>
                  </div>
                  <div className={styles.itemTotal}>₹{(item.price * item.quantity).toLocaleString()}</div>
                </div>
              ))}
            </div>

            <div className={styles.footer}>
              <div className={styles.total}>
                <span>Total</span>
                <span className={styles.totalAmt}>₹{total.toLocaleString()}</span>
              </div>
              <p className={styles.cartNote}>
                Your cart is saved — items will still be here if you refresh the page.
              </p>
              <button
                className="btn btn-primary"
                style={{ width: "100%", justifyContent: "center", padding: "12px" }}
                onClick={onCheckout}
              >
                Checkout with Stripe
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
